import { faIcon } from "@utils/faIcon"

import { ColorBadge } from "@atoms/index"

import { getObjectStatusStyle } from "@constants/objectStatusStyles"

import { ObjectStatusBadgeProps } from "./ObjectStatusBadge.types"

export default function ObjectStatusBadge(props: ObjectStatusBadgeProps) {
    const { objectType, status, statusLabelOverride, size = "md", tooltip } = props
    const statusColorOverride = props.objectType === "job" ? props.statusColorOverride : undefined
    const { colorScheme, icon, iconRotation } = getObjectStatusStyle(objectType, status, statusColorOverride)

    return (
        <ColorBadge
            variant="icon"
            colorScheme={colorScheme}
            icon={faIcon({ name: icon, style: "solid" })}
            iconRotation={iconRotation}
            size={size}
            tooltip={tooltip}
        >
            {statusLabelOverride ?? status}
        </ColorBadge>
    )
}
